export default __webpack_public_path__ + "static/media/testimonial2-150x150.fd5b5543.png";